import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Styles
import { SmartContainer, Stack, Surface, StyledStyledSideBarContainer } from '../../../styles/Containers'

// Components
import { FormInput } from '../../../components/Forms/FormInput';
import { PublishingForm } from '../../../components/Publishing/PublishingForm';


// Redux
import { StyledP } from '../../../styles/StyledHTML';
import { AssetSelect } from '../Assets/AssetSelect';
import { FullLocations } from './redux/locations.selectors';
import { deleteLocation, duplicateLocation, updateLocation } from './redux/locations.actions';

// ---------------------------
// Edit Example Taxonomy Form
// ---------------------------

export const EditLocationForm = ({ item, childrenMain, childrenSide, trigger }) => {

    const dispatch = useDispatch();
    const store = FullLocations();

    // Name
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState(false);
    const [nameHelperText, setNameHelperText] = useState('The title of the Product.')

    // Cover Photo
    const [coverPhoto, setCoverPhoto] = useState('');

    // Validate
    let disableSubmit = !name;

    // ---------------------------
    // Effects
    // ---------------------------

    // Sync Props
    useEffect(() => {
        if (item?.name) setName(item.name);
        else setName('')

        if (item?.meta?.coverPhoto) setCoverPhoto(item.meta.coverPhoto);
        else setCoverPhoto('');

    }, [item])


    // --------------------------
    // Interactions
    // --------------------------

    const handleSubmit = (publishing) => {

        // Payload
        const payload = {
            name,
            status: publishing.status,
            meta: {
                coverPhoto
            }
        }
        dispatch(updateLocation(item.id, payload));
    }

    // --------------------------
    // Slots
    // --------------------------

    const renderMainContentChildren = () => {
        if (!childrenMain) return (<div></div>)
        return (<SmartContainer>{childrenMain}</SmartContainer>)
    }

    const renderSideContentChildren = () => {
        if (!childrenSide) return (<div></div>)
        return (<SmartContainer>{childrenSide}</SmartContainer>)
    }




    // --------------------------
    // Render Form
    // --------------------------
    if (!item) return (<p>Loading...</p>)
    const assetFilters = {
        Location: `["${item.id}"]`,
    }



    return (
        <StyledStyledSideBarContainer thinking={store?.createLoading || store?.updateLoading || store?.duplicateLoading} minWidth="300px">
            <Stack>
                <Surface>
                    <Stack>
                        <FormInput label="Name" type="text" onChange={setName} value={name} helperText={nameHelperText} error={nameError} />
                        <AssetSelect label="Cover Photo" buttonText="Browse Photos" onChange={setCoverPhoto} filters={assetFilters} value={coverPhoto} />
                    </Stack>
                </Surface>
                {renderMainContentChildren()}
            </Stack>
            <SmartContainer>
                <Stack>

                    <PublishingForm
                        item={item}
                        onSubmit={handleSubmit}
                        disable={disableSubmit}
                        deleteAction={deleteLocation}
                        duplicateAction={duplicateLocation}
                        selector={FullLocations}
                        route="/locations"
                        withDuplicate={false}
                        withScheduling={false}
                        trigger={trigger}
                        hideSave={true}
                    />


                    {renderSideContentChildren()}
                </Stack>

            </SmartContainer>
        </StyledStyledSideBarContainer>
    )
}